import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import SelectDropDown from '../ReactHookForm/SelectDropDown';


function DropdownRenderer({ options, onSelect, handleClose }) {
    const { control, handleSubmit } = useForm();
    //const dropdownValue = watch("dropdownValue");
    const onSubmit = data => {
        onSelect(data.dropdownValue);
        handleClose();
    };

    // Adjust your options array to include the placeholder at the start

    const dropdownOptions = [
        { value: '', label: "Select #", disabled: true },
        ...options.map(option => typeof option === 'string' ? { value: option, label: option } : option)
    ];


    return (
        <form >
            <Controller
                name="dropdownValue"
                control={control}
                defaultValue="" // Set the default value to the first option
                render={({ field }) => <SelectDropDown
                    {...field}
                    options={dropdownOptions}
                    className="dropdown"
                    onChange={e => {
                        // Check if the selected value is not the placeholder
                        if (e.target.value !== '') {
                            field.onChange(e);
                            handleSubmit(onSubmit)();
                        }
                        // field.onChange(e);
                        //  handleSubmit(onSubmit)();
                    }}


                />}

            />
            {/* the below puts an invisible submit event upon drop down selection change*/}

            <input type="submit" style={{ display: 'none' }} />
        </form>
    );
}

export default DropdownRenderer;